import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const user = JSON.parse(localStorage.getItem('user') || '{}');
// Signed in: the account's language. Signed out: the language picked on the login screen,
// else the browser's (Vietnamese browsers start in Vietnamese).
const savedLng = localStorage.getItem('i18nextLng');
const browserLng = (navigator.language || '').toLowerCase().startsWith('vi') ? 'vi' : 'en';
const signedIn = !!localStorage.getItem('token');
const lng = user.language || (signedIn ? 'en' : ['vi', 'en'].includes(savedLng) ? savedLng : browserLng);

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng,
    fallbackLng: 'en',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Đường dẫn tới file dịch
    },
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;